import * as React from "react";
import { SVGProps } from "react";
const SvgVolumeMute = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#volume-mute_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m2.001 14.097 2 .728V21h4.897l.597.671L14 26.74v-8.274l2 .727v7.547a2 2 0 0 1-3.495 1.33L8.001 23h-4a2 2 0 0 1-2-2v-6.903Zm23.887 8.695 1.93.702c-.55.87-1.194 1.676-1.919 2.406-.577.576-1.202 1.1-1.87 1.568a.995.995 0 0 1-1.393-.246 1 1 0 0 1 .246-1.392 11.886 11.886 0 0 0 3.006-3.038Zm-6.056-2.205 2.101.765c-.092.102-.178.207-.276.305-.33.33-.688.63-1.07.897a1 1 0 0 1-1.145-1.64c.137-.096.26-.218.39-.327ZM1 9.54c.114 0 .229.019.342.061l30 10.919a1 1 0 1 1-.684 1.879l-30-10.919A.999.999 0 0 1 1 9.54Zm21.637-4.762a.997.997 0 0 1 1.392-.246c.667.468 1.293.992 1.87 1.568A13.91 13.91 0 0 1 30 16c0 .626-.056 1.243-.136 1.854l-1.921-.7a11.92 11.92 0 0 0-3.458-9.639 12.001 12.001 0 0 0-1.602-1.345 1 1 0 0 1-.246-1.392Zm-3.442 4.916a1 1 0 0 1 1.392-.248 7.942 7.942 0 0 1 3.399 6.268l-2.08-.757a5.95 5.95 0 0 0-2.464-3.871 1 1 0 0 1-.247-1.392ZM14 3.26a2 2 0 0 1 2 2v7.547l-2-.728V5.26l-4.505 5.07-.074.084L5.54 9h2.462l4.504-5.067A1.998 1.998 0 0 1 14 3.26Z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="volume-mute_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVolumeMute;
